/* istanbul ignore file */
import Settings from '../../utils/Settings';

export const settings = new Settings();
export const envSetup = new Settings();
export const appRegistrySetup = new Settings();
